import { ITheme } from "../../utils/theme";

export const brandContainer = (theme: ITheme) => ({
  background: theme.palette.coldWhite
});

export const brandIcon = { padding: '20px', paddingBottom: 0 };

export const brandText = (theme: ITheme) => ({
  fontFamily: "ProximaNovaSemibold",
  fontSize: '16px',
  color: 'black',
  padding: '20px'
});

export const contentContainer = (theme: ITheme) => ({
  background: theme.palette.neutralWhite,
  minHeight: 'calc(100vh - 64px)',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  positon: 'relative',
  padding: '20px'
});

export const contentBox = {
  marginBottom: "20px"
};

export const contentBoxSubheadline = (theme: ITheme) => ({
  color: theme.palette.corporateBlue,
  fontFamily: "ProximaNovaSemibold",
  fontSize: "18pt",
  marginBottom: '5px',
  marginTop: '5px'
});

export const contextBoxBody = (theme: ITheme) => ({
  color: theme.palette.black,
  fontFamily: "ProximaNovaLight",
  fontSize: '16px'
});

export const pdfIconStyle = (theme: ITheme) => ({
  fill: theme.palette.red[600]
});

export const newlineLinkStyle = {
  mt: 1,
  '& > .MuiTypography-root': {
    fontWeight: '400'
  },
}

export const linkStyle = {
  display: 'block',
  cursor: 'pointer',
  color: 'corporateBlue'
}